import { getAuth, signOut } from "firebase/auth";
import { deleteDoc, doc } from "firebase/firestore";
import { getToken } from "firebase/messaging";
// import { useNavigate } from "react-router-dom";
import { db, messaging } from "../../firebase";
import { clearLocalStorage } from "../localStorage/clearLocalStorage";

const Logout = () => {
  console.log("log out called");
  // const navigate = useNavigate();
  const userId = getAuth()?.currentUser?.uid;
  // try {
  //   signOut(getAuth()).then(() => {
  //     console.log("log out");
  //     clearLocalStorage();
  //   });
  // } catch (error) {
  //   console.log("log out error", error);
  // }
  let publicKey;

  if (process.env.REACT_APP_MY_PRODUCTION == 0) {
    publicKey =
      "BLqhTdZX9zgz87xM2sB3s9rSj8e--3ZEEJXP3uYo-NL1bPdGcUxf8RsmiaaGWxXDBE8Dze15jsmaMMDXO7fhVaA";
  } else {
    publicKey =
      "BPtF_Bjn_e67GCd2azLvfnJJx7wHsjf2TNzAkPvQOXAgHa_G4zUVgmiNfAmiUFCg2uwtGOhzMEEp14aBAdn3iR4";
  }
  getToken(messaging, { vapidKey: publicKey }).then(async (currentToken) => {
    try {
      if (currentToken) {
        deleteDoc(doc(db, "users", userId, "device_ids", currentToken));
      }
    } catch (err) {
      console.log("Device Token Error!" , err);
    }
  });
  const auth = getAuth();
  signOut(auth)
    .then(() => {
      console.log("logged out");
      clearLocalStorage();
    })
    .catch((error) => {
      console.log("log out error", error);
    });
};

export default Logout;
